// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"ede7b97b","390":"7570375b","700":"6f6b12a3"}[chunkId] + ".chunk.css";
};